import { render, staticRenderFns } from "./OrganizationSubPerimeterSelect.vue?vue&type=template&id=68718224"
import script from "./OrganizationSubPerimeterSelect.vue?vue&type=script&lang=js"
export * from "./OrganizationSubPerimeterSelect.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSubPerimeterSelect.vue?vue&type=style&index=0&id=68718224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports